import { useMonarchRule } from "../MonarchRulesProvider";
import {
  SearchFypEntryData,
  SearchFypEntryTestResult,
  UseSearchFypEntry,
} from "./types";

const CUSTOM_RULE_ID = "searchFypEntry";

const useSearchFypEntry: UseSearchFypEntry = () => {
  const { isLoading, value } = useMonarchRule<{
    data: SearchFypEntryData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
      data: {
        isVisible: false,
      },
    } as SearchFypEntryTestResult;
  }

  const data: SearchFypEntryData = value?.data ?? { isVisible: false };

  return {
    isLoading: false,
    variant: data.isVisible ? "test" : "control",
    data,
  };
};

export default useSearchFypEntry;
